import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Dropdown, Menu } from 'antd';
import { iconProfile, iconArrowRight } from 'assets/icons';
import { getAuth, isNullOrEmpty } from 'functions';
import COMMON_ACTION from 'model/actions/common';
import { handleAccountInfo, handleLogout } from 'model/constants/variableConstant';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppRoutes } from 'constants/appRoutes';
import { useNavigate } from 'react-router-dom';
import { getFullStringBase64 } from 'utils/media';
import { LINK_DEV } from 'constants/index';
import ContractAction from 'model/actions/contract';

export default function InfoUser({ isMobile }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContract = useSelector((state) => state.contract.contracts) ?? [];
  const countContract = listContract.length;
  const infoProfile = useSelector((state) => state.userProfile.data);

  const user = getAuth();

  const linkUserItems = [
    {
      icon: 'fa fa-user-o',
      iconColor: 'default',
      name: 'Thông tin cá nhân',
      function: handleAccountInfo,
    },
    {
      icon: 'sli-power',
      iconColor: 'default',
      name: 'Đăng xuất',
      function: () => {
        handleLogout();
        // window.location.href = `${LINK_DEV}/?logout`;
        dispatch(COMMON_ACTION.logout());
      },
    },
  ];

  useEffect(() => {
    dispatch(ContractAction.getListContract({ userCode: user?.userCode }));
  }, []);

  const menu = () => {
    let isLogin = !isNullOrEmpty(user);
    const rolePartner = isLogin && user.roles.find((item) => item === 'ROLE_PARTNER');
    return (
      <Menu>
        {user ? (
          !rolePartner ? (
            linkUserItems.map((item, index) => {
              return (
                <Menu.Item key={index} onClick={() => item.function()}>
                  {item.name}
                </Menu.Item>
              );
            })
          ) : (
            <Menu.Item key={'rolePartner'} onClick={() => linkUserItems[1].function()}>
              {linkUserItems[1].name}
            </Menu.Item>
          )
        ) : (
          ''
        )}
      </Menu>
    );
  };

  const getTypeUser = () => {
    const user = getAuth();
    switch (user?.userTypeCode) {
      case 'PERS':
        return '(cá nhân)';
      case 'COMP':
        return '(tổ chức)';
    }
  };

  const imgUser = infoProfile?.userImage
    ? getFullStringBase64(infoProfile?.userImage)
    : iconProfile;

  return (
    <div className='info-user-home'>
      <div className={`usser ${isMobile && 'responsive'}`}>
        <div className='wrap-info'>
          <div
            className='wrap-avatar'
            onClick={() => {
              navigate(AppRoutes.userProfile);
            }}
          >
            <img src={imgUser} alt='' />
          </div>
          <div className='flex flex-1 items-start justify-between'>
            <div>
              <p className='font-roboto-medium text-16px text-008BD2'>
                {' '}
                <span className='text-black'>Chào </span>
                {user ? user.fullName : 'Tài khoản'}
              </p>
              <p className='font-roboto-regular text-13px text-black'>
                <span className='text-7B7B7B'>Tài khoản </span>
                {user ? user.userCode : null} {getTypeUser()}
              </p>
            </div>
            <Dropdown
              overlay={menu}
              trigger={['click']}
              overlayStyle={{ minWidth: 150 }}
              placement='bottomRight'
            >
              <MoreVertIcon className='icon-more-vert' />
            </Dropdown>
          </div>
        </div>
      </div>

      <div className='wrap-info-contract' onClick={() => {}}>
        <p className='font-averta-regular text-black'>
          Số lượng hợp đồng:{' '}
          <span className='font-averta-bold text-008BD2'>{countContract} hợp đồng</span>
        </p>
        <img src={iconArrowRight} alt='' />
      </div>
      <hr className='border-b border-border-home opacity-50' />
    </div>
  );
}
